export default __webpack_public_path__ + "static/pingpong-sartoise-470a8f94fd4421243655e280a2b6a37a.jpg";